export default __webpack_public_path__ + "static/media/night.7ce85b85.svg";